// Add exports later on
import * as meteringpoints from '@appStore/metering-points/actions/metering-point.actions';
import * as meteringpointgroups from '@appStore/metering-points/actions/metering-point-group.actions';
import * as meteringpointvirtualgroup from '@appStore/metering-points/actions/metering-point-virtual-group.actions';
import * as agreements from '@appStore/metering-points/actions/agreement.actions';

export * from '@appStore/metering-points/actions/metering-point.actions';
export * from '@appStore/metering-points/actions/metering-point-group.actions';
export * from '@appStore/metering-points/actions/metering-point-virtual-group.actions';
export * from '@appStore/metering-points/actions/agreement.actions';

export const ActionTypes = {
  ...meteringpoints.MeteringPointActionTypes,
  ...meteringpointgroups.MeteringPointGroupActionTypes,
  ...meteringpointvirtualgroup.MeteringPointVirtualGroupActionTypes,
  ...agreements.AgreementActionTypes
};

export type Actions =
  | meteringpoints.MeteringPointActions
  | meteringpointgroups.MeteringPointGroupActions
  | meteringpointvirtualgroup.MeteringPointVirtualGroupActions
  | agreements.AgreementActions;
